import { render, staticRenderFns } from "./AddPersonTag.vue?vue&type=template&id=6259a7c8"
import script from "./AddPersonTag.vue?vue&type=script&lang=js"
export * from "./AddPersonTag.vue?vue&type=script&lang=js"
import style0 from "./AddPersonTag.vue?vue&type=style&index=0&id=6259a7c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports